import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getNonStructuredSectionAction } from '../actions';

const {
  useLoader: useNonStructuredSectionLoader,
  useLoaderData: useNonStructuredSectionLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getNonStructuredSectionAction,
});

function NonStructuredSectionLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  NonStructuredSectionLoader,
  useNonStructuredSectionLoaderData,
  useNonStructuredSectionLoader,
};
